import { createContext, useContext } from 'react';
import type { SupportedLocales, FallbackLocale, LocaleID, IntlProviderOptions } from './services/I18n';
import { getIntlConfigByLocale } from './util';
// import { getIntlConfigByLocale } from './util/getIntlConfigByLocale';
// import type { DecodedJsonData } from './util/getIntlConfigByLocale';
export type LocaleConfigObject = {
  locale?: LocaleID;
  translations?: {
    [key:string]: any
  };
}

export type I18nContextType = {
  defaultNS: string,
  supportedLocales: SupportedLocales,
  fallbackLocale: FallbackLocale,
  translations: { [key: string]: any; };
  locale?: LocaleID,
  updateLocale: (v:LocaleID) => void,
  apiService: (v: LocaleID, options: Pick<IntlProviderOptions, "apiService">) => Promise<LocaleConfigObject>
  providerOptions?: IntlProviderOptions;
}

const defaultValue:I18nContextType = {
  defaultNS: 'translations',
  supportedLocales: new Set(['en', 'en-US']),
  fallbackLocale: 'en',
  translations: {},
  /* eslint-disable-next-line @typescript-eslint/no-unused-vars */
  updateLocale: (v) => {},
  /* eslint-disable-next-line @typescript-eslint/no-unused-vars */
  apiService: getIntlConfigByLocale ,
  providerOptions: {
    apiService: {
      basePath: './static/locale'
    }
  }
};

const I18nContext = createContext<I18nContextType>(defaultValue);

export const getDefaultValue = () => defaultValue;

export default I18nContext;

const useI18nContext = () => useContext(I18nContext);

export {
  I18nContext,
  useI18nContext
};
